
import React, { useState } from "react";
import { auth, db } from "../FirebaseComp/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

import "./login.css";

// import { Eye, EyeOff } from "lucide-react";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();


  //PASSWORD VIEW
const [showPassword, setShowPassword] = useState(false);


  const login = async () => {
    try {
      // Sign in the user
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      // Fetch the user's role from Firestore
      const userDoc = await getDoc(doc(db, "users", userId));
      if (userDoc.exists()) {
        const { role } = userDoc.data();

        // Navigate to the appropriate dashboard based on role
           if (role === "admin") {
          navigate("/AdminPanel");
        } else if (role === "customer") {
          navigate("/CustomerDashboard");
        } else if (role === "sub-admin") {
          navigate("/sub-adminPanel");
        
        } 
        

        else {
          alert("Role not recognized. Contact admin.");
        }
      } else {
        alert("No user data found. Please contact admin.");
      }
    } catch (error) {
      console.error("Error logging in:", error.message);
      alert(error.message);
    }
  };



  const navigateToForgotPassword = () => {
   
    navigate('/ForgotPassword');
  };

  return (

<div className="login-container">
      <div className="login-panel">
        <div className="left-panel">
          <h1 className="heading-login">Login Panel</h1>
          <input
            type="email"
            placeholder="Please Enter Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type={showPassword ? "text" : "password"}  // Toggle input type based on showPassword state
            placeholder="Please Enter Your Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          
          {/* <button
  type="button"
  onClick={() => setShowPassword(!showPassword)}
  style={{
    position: "absolute",
    top: window.innerWidth <= 360 ? "32%" : window.innerWidth <= 375 ? "31%" : window.innerWidth <= 441 ? "36%" :   window.innerWidth <= 480 ? "37%" : window.innerWidth <= 768 ? "38%" : "45%",
    right: window.innerWidth <= 480 ? "-150px" : window.innerWidth <= 768 ? "-130px" : "45px",
    transform: "translateY(-50%)",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#aaa",
    transition: "color 0.3s",
    padding: "5px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}  
</button> */}


          {/* Forgot Password Link */}
          <div>

          </div>

          <button onClick={login}>Login</button>
        </div>
        <div className="right-panel">
          <img src="eye-world.png" alt="Eye World Logo" className="logo" />
          <h4>
            Optical Management System
          </h4><br />
          <p >
            Powered By<strong> GLAXMORE IT </strong>This System designed,  
            Streamline your operations with ease, accuracy, and reliability.  
          </p>
        </div>
      </div>
    </div>

  );
};

export default Login;
